var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPentagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5474 1.86661C9.81512 1.66399 10.1849 1.66399 10.4526 1.86661L18.2173 7.74302C18.4695 7.93389 18.5748 8.26246 18.4806 8.56439L15.4904 18.1508C15.3927 18.4641 15.1026 18.6774 14.7745 18.6774H5.22554C4.89736 18.6774 4.60729 18.464 4.50956 18.1508L1.51936 8.56439C1.42518 8.26246 1.53053 7.93389 1.78273 7.74302L9.5474 1.86661Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagon);
export default __webpack_public_path__ + "static/media/pentagon.7095d3d7efd20c4b4eccd802ef737190.svg";
export { ForwardRef as ReactComponent };